import { createFormFields } from '@/shared/components/form-fields/factories/create-form-fields';
import { useFieldContext } from './followup-inspection-form-context.hook';

/**
 * Form fields configurados para o contexto de Proposals
 *
 * Todos os componentes já estão conectados ao contexto correto
 * do formulário de proposals através do useFieldContext.
 *
 * @example
 * ```tsx
 * import { ProposalFormFields } from './hooks/form-fields';
 *
 * <form.Field name="customerName">
 *   <ProposalFormFields.TextField label="Nome do Cliente" required />
 * </form.Field>
 * ```
 */
export const ProposalFormFields = createFormFields(useFieldContext);

// Re-export types para facilitar o uso
export type {
  CalendarFieldProps,
  CheckboxFieldProps,
  DateFieldProps,
  NumberFieldProps,
  RadioButtonGroupProps,
  RadioButtonOption,
  RadioCardFieldProps,
  RadioCardOption,
  SelectFieldOption,
  SelectFieldProps,
  TextareaFieldProps,
  TextFieldProps,
  UploadFieldProps
} from '@/shared/components/form-fields/factories/create-form-fields';

